module.exports = __webpack_public_path__ + "media/sheik.4f196879.wav";